<div class="selfie-verification-container">
  <div *ngIf="verificationCompleted" class="verification-success-message my-3">
    <div class="alert alert-success border-0">
      <div class="d-flex align-items-center">
        <i class="icon-check me-2" style="color: #28a745"></i>
        <span
          ><strong
            >{{ 'Face ID verification passed successfully' | translate }}
          </strong></span
        >
      </div>
    </div>
  </div>

  <div *ngIf="!verificationCompleted">
    <div class="selfie-instructions mb-4">
      <div *ngIf="field.props?.['descriptionText']; else defaultInstructions">
        <div [innerHTML]="field.props['descriptionText'] | translate"></div>
      </div>

      <ng-template #defaultInstructions>
        <ol class="ps-4">
          <li class="mb-2">
            <b>{{ 'Start with good lighting' | translate }}</b>
            <div class="text-muted">
              {{
                'For a clear photo, move to a well-lit space or adjust your lighting.'
                  | translate
              }}
            </div>
          </li>
          <li class="mb-2">
            <b>{{ 'Make sure we can see your face' | translate }}</b>
            <div class="text-muted">
              {{
                'Double check that your entire face is visible. No hats or sunglasses please.'
                  | translate
              }}
            </div>
          </li>
        </ol>
      </ng-template>
    </div>

    <button
      type="button"
      class="btn btn-primary w-100"
      (click)="openVerificationModal()">
      {{ field.props['buttonText'] || 'Open camera' | translate }}
    </button>
  </div>
</div>
